"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultButtonStyle = exports.getIconSizeText = exports.getIconSize = void 0;
const clsx_1 = __importDefault(require("clsx"));
const tailwind_variants_1 = require("tailwind-variants");
// ICON SIZE
const getIconSize = (desktopSize, mobileSize) => {
    if (desktopSize && mobileSize) {
        // pcSize와 mobileSize가 모두 존재하는 경우
        return `${getIconSizeClass(mobileSize)} ${getIconSizeClass(desktopSize, true)}`;
    }
    else if (desktopSize) {
        // pcSize만 존재하는 경우
        return getIconSizeClass(desktopSize, true);
    }
    else if (mobileSize) {
        // mobileSize만 존재하는 경우
        return getIconSizeClass(mobileSize);
    }
    return 'size-16'; // 기본값
};
exports.getIconSize = getIconSize;
const getIconSizeClass = (size, isDesktop = false) => {
    const prefix = isDesktop ? 'desktop:' : '';
    switch (size) {
        case 'large':
            return `${prefix}size-16`;
        case 'medium':
            return `${prefix}size-14`;
        case 'small':
            return `${prefix}size-12`;
        default:
            return `${prefix}size-16`;
    }
};
// TEXT ICON SIZE
const getIconSizeText = (desktopSize, mobileSize) => {
    if (desktopSize && mobileSize) {
        // pcSize와 mobileSize가 모두 존재하는 경우
        return `${getTextIconSizeClass(mobileSize)} ${getTextIconSizeClass(desktopSize, true)}`;
    }
    else if (desktopSize) {
        // pcSize만 존재하는 경우
        return getTextIconSizeClass(desktopSize, true);
    }
    else if (mobileSize) {
        // mobileSize만 존재하는 경우
        return getTextIconSizeClass(mobileSize);
    }
    return 'size-20'; // 기본값
};
exports.getIconSizeText = getIconSizeText;
const getTextIconSizeClass = (size, isDesktop = false) => {
    const prefix = isDesktop ? 'desktop:' : '';
    switch (size) {
        case 'large':
            return `${prefix}size-20`;
        case 'medium':
            return `${prefix}size-16`;
        case 'small':
            return `${prefix}size-12`;
        default:
            return `${prefix}size-20`;
    }
};
exports.defaultButtonStyle = (0, tailwind_variants_1.tv)({
    base: (0, clsx_1.default)('rounded-30 relative flex items-center justify-center'),
    // base: clsx('rounded-30 relative flex items-center justify-center', 'text-title-5', 'desktop:text-header-5'),
});
